import {
  faCalendarCheck,
  faCloud,
  faDesktop,
  faHeadset,
  faLaptopMedical,
  faMobileAlt,
  faTty,
  faUserMd,
} from "@fortawesome/free-solid-svg-icons";
import { ListItem } from "components/list/ListItem";
import React from "react";

export const PlanosList = () => {
  return (
    <ul className="col planos__list">
      {PLANOS_LIST.map((i, index) => {
        return (
          <ListItem
            key={index}
            itemClass={i.itemClass}
            iconName={i.iconName}
            iconClass={i.iconClass}
            text={i.text}
          />
        );
      })}
    </ul>
  );
};

const PLANOS_LIST = [
  {
    itemClass: "d-flex align-items-center py-2",
    iconName: faUserMd,
    iconClass: "text-primary mr-3",
    text: "1 Médico",
    textClass: "planos__list-text",
  },
  {
    itemClass: "d-flex align-items-center py-2",
    iconName: faTty,
    iconClass: "text-primary mr-3",
    text: "2 Secretárias gratuitas",
    textClass: "planos__list-text",
  },
  {
    itemClass: "d-flex align-items-center py-2",
    iconName: faCloud,
    iconClass: "text-primary mr-3",
    text: "Acesso 100% Online e 24x7",
    textClass: "planos__list-text",
  },
  {
    itemClass: "d-flex align-items-center py-2",
    iconName: faLaptopMedical,
    iconClass: "text-primary mr-3",
    text: "Prontuário Customizado por Especialidade",
    textClass: "planos__list-text",
  },
  {
    itemClass: "d-flex align-items-center py-2",
    iconName: faCalendarCheck,
    iconClass: "text-primary mr-3",
    text: "Agenda Web Sincronizada",
    textClass: "planos__list-text",
  },
  {
    itemClass: "d-flex align-items-center py-2",
    iconName: faHeadset,
    iconClass: "text-primary mr-3",
    text: "Suporte e Treinamento Online",
    textClass: "planos__list-text",
  },
  {
    itemClass: "d-flex align-items-center py-2",
    iconName: faMobileAlt,
    iconClass: "text-primary mr-3",
    text: "App ProntLife para Médicos e Pacientes",
    textClass: "planos__list-text",
  },
  {
    itemClass: "d-flex align-items-center py-2",
    iconName: faDesktop,
    iconClass: "text-primary mr-3",
    text: "20 Teleconsultas gratuitas por mês (promoção!)",
    textClass: "planos__list-text",
  },
];
